import { Image, LI } from "../../../../AbstractElements";
import { GROUPING_THIRD } from "../../../../Data/UiKit/Avatars";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const GroupinThird = () => {
  return (
    <div className="customers d-inline-block avatar-group">
      <ul className="simple-list">
        <LI className="d-inline-block">
          <Image className="img-40 rounded-circle" src={dynamicImage("user/3.jpg")} alt="image" />
        </LI>
        {GROUPING_THIRD.map(({ src }, index) => (
          <LI className="d-inline-block" key={index}>
            <Image className="img-40 rounded-circle" src={src} alt="image" />
          </LI>
        ))}
      </ul>
    </div>
  );
};
